<script>
import Professionals from "@/components/_Shared/OrdersAndSubscriptions/Professionals";
import DayAndFrequency from "@/components/_Shared/OrdersAndSubscriptions/DayAndFrequency";
import Period from "@/components/_Shared/OrdersAndSubscriptions/Period";
import ConfirmPeriodPrice from "@/components/_Shared/OrdersAndSubscriptions/ConfirmPeriodPrice";

import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("newPurchase", [
      "professional_id",
      "day_of_week",
      "frequency",
      "start_at",
      "end_at"
    ])
  },

  components: {
    Professionals,
    DayAndFrequency,
    Period,
    ConfirmPeriodPrice
  }
};
</script>

<template>
  <div class="mb-40 section" id="PerProfessional">
    <transition name="fade" mode="out-in">
      <Professionals title="ESCOLHA UM PROFISSIONAL" :class="{'passed-on': professional_id}"/>
    </transition>

    <transition name="fade" mode="out-in">
      <DayAndFrequency v-show="professional_id"/>
    </transition>

    <transition name="fade" mode="out-in">
      <Period v-show="frequency"/>
    </transition>

    <transition name="fade" mode="out-in">
      <ConfirmPeriodPrice v-show="end_at" @scrollTo="$emit('scrollTo', $event)"/>
    </transition>
  </div>
</template>

<style scoped>
div {
  transition: all 0.24s ease;
}

.section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.section.passed-on .passed-on {
  opacity: 1;
}

.passed-on {
  opacity: 0.35;
}

.passed-on:hover {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Subscription/NewSubscription/PerProfessional.vue